/**
 * InputValidator - Stateless Client-seitige Eingabe-Validierung (Mirror von Server)
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

// Client-seitige Validierungs-Konstanten (Mirror von Server)
export const VALIDATION = {
    MAX_NAME_LENGTH: 20,
    MIN_NAME_LENGTH: 1,
    MAX_MESSAGE_LENGTH: 200,
    GAME_ID_PATTERN: /^[a-zA-Z0-9]{6}$/,
    VALID_COLOR_IDS: ['red', 'blue', 'green', 'yellow', 'purple', 'cyan', 'pink', 'lime', 'orange', 'gold'],
    VALID_VIRUS_TYPES: ['classic', 'spiky', 'blob', 'crystal', 'toxic', 'digital']
};

/**
 * Validiert und sanitized einen Spielernamen
 * @param {string} name - Eingabe-Name
 * @returns {string|null} - Bereinigter Name oder null bei Fehler
 */
export function validatePlayerName(name) {
    if (typeof name !== 'string') return null;

    // Trimmen und HTML entfernen
    const cleaned = name.trim().replace(/<[^>]*>/g, '');

    if (cleaned.length < VALIDATION.MIN_NAME_LENGTH) return null;
    if (cleaned.length > VALIDATION.MAX_NAME_LENGTH) {
        return cleaned.substring(0, VALIDATION.MAX_NAME_LENGTH);
    }

    return cleaned;
}

/**
 * Validiert eine Game-ID
 * @param {string} gameId - Game-ID
 * @returns {boolean} - true wenn gültig
 */
export function validateGameId(gameId) {
    return typeof gameId === 'string' && VALIDATION.GAME_ID_PATTERN.test(gameId);
}

/**
 * Validiert eine Color-ID
 * @param {string} colorId - Color-ID (z.B. 'red', 'blue')
 * @returns {boolean} - true wenn gültig
 */
export function validateColorId(colorId) {
    return typeof colorId === 'string' && VALIDATION.VALID_COLOR_IDS.includes(colorId);
}

/**
 * Validiert einen Virus-Typ
 * @param {string} virusType - Virus-Typ
 * @returns {boolean} - true wenn gültig
 */
export function validateVirusType(virusType) {
    return typeof virusType === 'string' && VALIDATION.VALID_VIRUS_TYPES.includes(virusType);
}

/**
 * Gebündelter Zugriff (static-artiges Objekt)
 */
export const InputValidator = {
    VALIDATION,
    validatePlayerName,
    validateGameId,
    validateColorId,
    validateVirusType
};

export default InputValidator;
